import { useQuery } from '@tanstack/react-query';

import { getResolvedTerms, type TermsScope } from '@/services/terms';

export const TERMS_RESOLVE_QUERY_KEY = 'terms-resolve';

export default function useResolvedTerms({
  type,
  entityIds = [],
  enabled = entityIds.length > 0,
}: {
  type: TermsScope;
  // Omitted for STUDIO scope, which resolves from the tenant alone.
  entityIds?: string[];
  enabled?: boolean;
}) {
  const idsKey = [...entityIds].sort().join(',');
  const query = useQuery({
    queryKey: [TERMS_RESOLVE_QUERY_KEY, type, idsKey],
    queryFn: () => getResolvedTerms({ type, entity_ids: idsKey || undefined }),
    enabled,
  });

  return {
    docs: query.data ?? [],
    // isPending rather than isLoading, because on the render where `enabled`
    // flips true the fetch has not started, so isLoading (isPending &&
    // isFetching) is false and the caller falls through to its empty state for
    // a frame. Gated on `enabled` because a disabled query stays pending
    // forever, which would report a caller that asked for nothing as loading
    // with no way out.
    isLoading: enabled && query.isPending,
    isError: query.isError,
    refetch: query.refetch,
  };
}
